export enum AssignmentAgendaEnum {
  WATCHLIST = 'watchlist',
  MAKE_DECISION = 'makeDecision',
}
